export function convertTimestampToSeconds(timestamp: number): number {
  const MILISECONDS_IN_1973 = 99999999999;
  return Math.round(timestamp > MILISECONDS_IN_1973 ? timestamp / 1000 : timestamp);
}

export const generateTimestamp = () => new Date().getTime();
